var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A2470EBC-FDF5-467A-8469-B3C75474CFCF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E99EF9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE53E4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26ECB0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FCC93",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.97475,8.75691667 C16.1663333,8.69183333 16.3744167,8.69183333 16.566,8.75691667 L21.3785,10.3940833 C21.7506667,10.5205833 22,10.8689167 22,11.2621667 L22,14.9453333 C22,19.5900833 16.84925,21.8331667 16.6301667,21.9266667 C16.5155833,21.9761667 16.39275,22 16.2708333,22 C16.1489167,22 16.0260833,21.9761667 15.9105833,21.9275833 C15.6915,21.8340833 10.54075,19.5900833 10.54075,14.9453333 L10.54075,11.2621667 C10.54075,10.8698333 10.791,10.5205833 11.16225,10.3940833 Z M13.0625,0 C14.4558333,0 15.5833333,1.1275 15.5833333,2.52083333 L15.5833333,6.96666667 C15.51,6.97583333 15.4458333,6.99416667 15.3816667,7.02166667 L12.7691667,7.91083333 C12.6316667,7.57166667 12.3016667,7.33333333 11.9166667,7.33333333 L3.66666667,7.33333333 C3.1625,7.33333333 2.75,7.74583333 2.75,8.25 C2.75,8.75416667 3.1625,9.16666667 3.66666667,9.16666667 L9.69833333,9.16666667 C9.12083333,9.63416667 8.75416667,10.3491667 8.7175,11.1283333 C8.58,11.0458333 8.42416667,11 8.25,11 L3.66666667,11 C3.1625,11 2.75,11.4125 2.75,11.9166667 C2.75,12.4208333 3.1625,12.8333333 3.66666667,12.8333333 L8.25,12.8333333 C8.415,12.8333333 8.57083333,12.7875 8.70833333,12.705 L8.70833333,14.9416667 C8.70833333,16.5916667 9.22166667,18.0308333 9.99166667,19.25 L2.52083333,19.25 C1.1275,19.25 0,18.1225 0,16.7291667 L0,2.52083333 C0,1.1275 1.1275,0 2.52083333,0 Z M19.34075,12.5583333 C18.9365,12.254 18.36175,12.3374167 18.0583333,12.7416667 L15.9426667,15.5631667 L14.8564167,14.4769167 C14.498,14.1185 13.9186667,14.1185 13.56025,14.4769167 C13.2018333,14.8353333 13.2018333,15.4146667 13.56025,15.7730833 L15.3935833,17.6064167 C15.5659167,17.7796667 15.79875,17.875 16.0416667,17.875 C16.06275,17.875 16.08475,17.8740833 16.10675,17.87225 C16.3725833,17.8539167 16.6155,17.721 16.775,17.5083333 L19.525,13.8416667 C19.8293333,13.4365 19.7468333,12.86175 19.34075,12.5583333 Z M7.33333333,3.66666667 L3.66666667,3.66666667 C3.1625,3.66666667 2.75,4.07916667 2.75,4.58333333 C2.75,5.0875 3.1625,5.5 3.66666667,5.5 L7.33333333,5.5 C7.8375,5.5 8.25,5.0875 8.25,4.58333333 C8.25,4.07916667 7.8375,3.66666667 7.33333333,3.66666667 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-+-Tech-Demo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "S_Match-Results-+-hover",
    transform: "translate(-896.000000, -767.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "therapist-card",
    transform: "translate(413.000000, 603.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "insurance",
    transform: "translate(483.000000, 137.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    transform: "translate(0.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-2)",
    xlinkHref: "#path-3"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInNetwork);
export default __webpack_public_path__ + "static/media/icon-inNetwork.34b85ad30d9ddd35d830eec8743a1236.svg";
export { ForwardRef as ReactComponent };